import axios, { AxiosError } from "axios";
import { getTokenCookie, setTokenCookie, tokensPublico } from "@/libs/cookie";
import { config } from "@/config";

export const apiPublica = axios.create({
  baseURL: config.apiUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

apiPublica.interceptors.request.use((config) => {
  const tokenAccess = getTokenCookie(tokensPublico.validAcces);

  if (tokenAccess) {
    config.headers.Authorization = `Bearer ${tokenAccess}`;
  }

  return config;
});

apiPublica.interceptors.response.use(
  (response) => { 
    const publicAuthorizationRoutes = [
      '/api/publico/iptu/imoveis'
    ]
    
    if (publicAuthorizationRoutes.includes(response.config.url as string) ) {
      setTokenCookie(tokensPublico.validAcces, response.data.token, 60 * 5)
    }

    return response; 
  },
  (error: AxiosError) => {

    if ( error.response?.status === 401 ) {
      return Promise.reject(accessDenied(error));

    }

    return Promise.reject(errorHandler(error));
  }
);

export type ErrorApi  = {
  success: boolean;
  data: any | { message: string },
  status: number
}

const accessDenied = (error: any): ErrorApi => {
  return {
    success: false,
    data: { message: "Você demorou um pouco. Tente Novamente!" },
    status: 401,
  };
}

export const errorHandler = (error: any): ErrorApi =>  {
  const response = error.response;
  return {
    success: false,
    data: response?.data || { message: "Ops! Ocorreu um erro. Tente Novamente!" },
    status: response?.data?.status || response?.status,
  };
};
